
export class CreateMessageRequestDto {
  text?: string;
  currentPartnerId?: string;
  partnerIds?: string;
}
